export const PRODUCT_GET_LIST = "/product";